"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaginationInfo = /** @class */ (function () {
    function PaginationInfo(data) {
        this.currentPage = 1;
        this.limit = 30;
        this.totalRecords = 0;
        this.pageCount = 0;
        this.totalValue = undefined;
        if (data) {
            this.currentPage = data.currentPage || data.current_page || 1;
            this.limit = data.limit || data.per_page || 30;
            this.totalRecords = data.totalRecords || data.total || 0;
            this.pageCount = data.pageCount || data.last_page || 0;
            this.totalValue = data.totalValue || data.total_value || undefined;
        }
    }
    Object.defineProperty(PaginationInfo.prototype, Symbol.toStringTag, {
        get: function () {
            return 'PaginationInfo';
        },
        enumerable: false,
        configurable: true
    });
    return PaginationInfo;
}());
exports.default = PaginationInfo;
